import request from './plugins/request'

// 新建一条
export let createArticle = (params = {}) => {
    return request({
        url: '/article',
        params: params,
        method: 'post'
    })
}

// 获取列表
export let getArticleList = (params = {}) => {
    return request({
        url: '/article',
        params: params
    })
}


//获取某一条的详情
export let getArticleDetails = (params) => {
    return request({
        url: '/article/'+params
    })
}

//删除某一条
export let deleteArticle = (params) => {
    return request({
        url: '/article/'+params,
        method: 'delete'
    })
}

//修改某一条
export let putArticle = (params,id) => {
    return request({
        url: '/article/'+id,
        method: 'put',
        params: params
    })
}

//新增接口
export let getRecommend = (params = {}) => {
    return request({
        url: '/article/recommend',
        params:params
    })
}

//新增接口
export let updateCounter = (params = {}) => {
    return request({
        url: '/article/counter',
        params:params,
    })
}


